import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const instanceNameValidator = (allInstances):  ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
  let diffName = true;
    allInstances?.forEach(instance => {
      if (control?.value?.toLowerCase() === instance?.name?.toLowerCase()) {
          diffName = false;
      }
    })
    return diffName ? null : {name: {value: control.value}};
  };
}

/**
 * Validates the environment field
 */
export const instanceEnvironmentValidator = (allInstances: any[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control?.value || !Array.isArray(allInstances)) {
      return null;
    }
    const inputValue = control.value.trim().toLowerCase();
    const isDuplicate = allInstances.some(instance =>
      instance?.targetEnvironment?.toLowerCase() === inputValue
    );
    return isDuplicate ? { notUniqueEnvironment: { value: control.value } } : null;
  };
};
